<template>
  <header class="fixed top-0 left-0 z-30 w-full bg-white shadow-shadow py-[9px] header">
    <div
      class="flex items-center justify-between max-w-screen-sm px-5 mx-auto md:max-w-screen-md lg:max-w-screen-lg xl:max-w-screen-xl"
    >
      <a
        v-if="!hideHeader"
        class="flex items-center gap-3 font-wide font-medium text-[20px] leading-[20px] tracking-[0] uppercase text-[#1D2023]"
        :href="isAuth ? '/products' : '/'"
      >
        <div class="w-[247px] h-[39px] min-w-[247px]">
          <HeaderLogo />
        </div>
      </a>
      <div
        v-else
        class="flex items-center gap-3 font-wide font-medium text-[20px] leading-[20px] tracking-[0] uppercase text-[#1D2023] cursor-default"
      >
        <div class="w-[247px] h-[39px] min-w-[247px]">
          <HeaderLogo />
        </div>
      </div>
      <div class="flex items-center gap-4">
        <div
          v-if="!hideHeader"
          class="header__menu md:gap-4"
        >
          <inertia-link
            v-if="isAuth && $page.props.user.register_completed"
            class="md:flex items-center py-2.5 font-compact font-medium text-[14px] leading-[20px] tracking-[0] text-[#1D2023] hidden"
            :class="{ 'is-active': $window.location.pathname === '/products' }"
            href="/products"
          >
            Продукты для тестирования
          </inertia-link>

          <a
            v-if="
              isAuth && $page.props.abilities.quick_tests_access
            "
            class="md:flex items-center py-2.5 font-compact font-medium text-[14px] leading-[20px] tracking-[0] text-[#1D2023] hidden"
            href="/ux-ui-tests"
          >
            Исследования
          </a>

          <a
            v-if="isAuth && $page.props.abilities.store_access"
            class="md:flex items-center py-2.5 font-compact font-medium text-[14px] leading-[20px] tracking-[0] text-[#1D2023] hidden"
            href="/store"
            target="_blank"
          >
            Магазин
          </a>

          <DropdownMenu>
            <template #title>
              <a
                class="cursor-pointer md:flex items-center py-2.5 font-compact font-medium text-[14px] leading-[20px] tracking-[0] text-[#1D2023] hidden"
                target="_blank"
              ><span
                class="py-1"
              >Поддержка</span></a>
            </template>

            <template #content>
              <ExternalLink
                class="p-1.5 bg-transparent hover:bg-divider/25 rounded-xl font-compact font-normal text-sm text-txt"
                href="https://support.mts.ru/betatesting"
              >
                Справка
              </ExternalLink>
              <a
                class="p-1.5 bg-transparent hover:bg-divider/25 rounded-xl font-compact font-normal text-sm text-txt"
                href="/ask_question"
                target="_blank"
              >
                Задать вопрос
              </a>
              <a
                class="p-1.5 bg-transparent hover:bg-divider/25 rounded-xl font-compact font-normal text-sm text-txt"
                href="/videos"
                target="_blank"
              >
                Видеоинструкции
              </a>
            </template>
          </DropdownMenu>

          <inertia-link
            v-if="
              $page.props.internal_visitor === true &&
                !$page.props.disableTopTestersPage &&
                isAuth && $page.props.abilities.cash_reward_access
            "
            class="md:flex items-center p-2.5 font-compact font-medium text-[14px] leading-[20px] tracking-[0] text-[#1D2023] hidden"
            href="/top"
          >
            Денежное вознаграждение
          </inertia-link>

          <!--          <inertia-link-->
          <!--            class="header__menu-item"-->
          <!--            href="/"-->
          <!--          >-->
          <!--            Запустить тестирование-->
          <!--          </inertia-link>-->

          <!--          <DropdownMenu v-if="isAuthAlphaTester">-->
          <!--            <template #title>-->
          <!--              <a-->
          <!--                class="header__menu-item"-->
          <!--                href="https://shop.mts.ru/"-->
          <!--              >-->
          <!--                Магазин-->
          <!--              </a>-->
          <!--            </template>-->

          <!--            <template #content>-->
          <!--              <inertia-link href="/">-->
          <!--                История покупок-->
          <!--              </inertia-link>-->
          <!--            </template>-->
          <!--          </DropdownMenu>-->
          <div class="header__right">
            <div class="profile-widget-host">
              <profile-widget />
            </div>
          </div>
        </div>

        <div class="header__hamburger">
          <div
            class="hamburger hamburger--squeeze"
            :class="{ 'is-active': showMenu }"
            @click.prevent="toggleMenu"
          >
            <div class="hamburger-box">
              <div class="hamburger-inner" />
            </div>
          </div>
        </div>

        <div
          id="mobile-nav"
          class="mobile-navi"
          :class="{ 'is-active': showMenu }"
        >
          <div class="header__menu header__menu--mobile">
            <template v-if="!isAuth">
              <a
              class="header__menu-item"
              href="/oauth/redirect"
              target="_blank"
              >Войти</a>
            </template>
            <template v-if="isAuth">
              <template v-if="hasAccessAdmin">
                <inertia-link
                  class="header__menu-item"
                  href="/profile"
                >
                  <img
                    src="@app/assets/img/icon-minus.svg"
                    alt="icon"
                    width="15px"
                  > Личный кабинет
                </inertia-link>
                <a
                      class="md:flex items-center p-2.5 font-compact font-medium text-[14px] leading-[20px] tracking-[0] text-[#1D2023] hidden btn--admin"
                  :href="legacyUrl()"
                >
                  <img
                    src="@app/assets/img/icon-minus.svg"
                    alt="icon"
                    width="15px"
                  > Панель администратора
                </a>
              </template>
              <inertia-link
                v-else-if="$page.props.user.register_completed"
                class="header__menu-item"
                href="/profile"
              >
                <img
                  src="@app/assets/img/icon-minus.svg"
                  alt="icon"
                  width="15px"
                > Личный кабинет
              </inertia-link>
              <a
                v-else
                class="header__menu-item"
                href="/oauth/register"
              >
                <img
                  src="@app/assets/img/icon-minus.svg"
                  alt="icon"
                  width="15px"
                > Закончить регистрацию
              </a>

              <inertia-link
                v-if="$page.props.user.register_completed"
                class="header__menu-item"
                href="/products"
              >
                Продукты для тестирования
              </inertia-link>

              <inertia-link
                v-if="isAuth && $page.props.abilities.quick_tests_access"
                class="header__menu-item"
                href="/ux-ui-tests"
              >
                <img
                  src="@app/assets/img/icon-minus.svg"
                  alt="icon"
                  width="15px"
                > Запуск и управление тестами
              </inertia-link>

              <a
                v-if="isAuth && $page.props.abilities.store_access"
                class="header__menu-item"
                href="/store"
                target="_blank"
              >
                <img
                  src="@app/assets/img/icon-minus.svg"
                  alt="icon"
                  width="15px"
                > Магазин
              </a>

              <inertia-link
                class="header__menu-item"
                href="/products?participating=true"
              >
                <img
                  src="@app/assets/img/icon-minus.svg"
                  alt="icon"
                  width="15px"
                > Участвую
              </inertia-link>
              <inertia-link
                class="header__menu-item"
                href="/products?participating=false"
              >
                <img
                  src="@app/assets/img/icon-minus.svg"
                  alt="icon"
                  width="15px"
                > Не участвую
              </inertia-link>
            </template>

            <!--        <inertia-link-->
            <!--          class="header__menu-item"-->
            <!--          href="/"-->
            <!--        >-->
            <!--          Запустить тестирование-->
            <!--        </inertia-link>-->

            <!--        <template v-if="isAuthAlphaTester">-->
            <!--          <a-->
            <!--            class="header__menu-item"-->
            <!--            href="https://shop.mts.ru/"-->
            <!--          >-->
            <!--            Магазин-->
            <!--          </a>-->
            <!--          <inertia-link-->
            <!--            class="header__menu-item"-->
            <!--            href="/"-->
            <!--          >-->
            <!--            <img-->
            <!--              src="@app/assets/img/icon-minus.svg"-->
            <!--              alt="icon"-->
            <!--              width="15px"-->
            <!--            > История покупок-->
            <!--          </inertia-link>-->
            <!--        </template>-->

            <ExternalLink
              class="header__menu-item"
              href="https://support.mts.ru/betatesting"
            >Поддержка
            </ExternalLink>
            <inertia-link
              class="header__menu-item"
              href="/videos"
            >
              <img
                src="@app/assets/img/icon-minus.svg"
                alt="icon"
                width="15px"
              > Видеоинструкции
            </inertia-link>
            <inertia-link
              class="header__menu-item"
              href="/ask_question"
            >
              <img
                src="@app/assets/img/icon-minus.svg"
                alt="icon"
                width="15px"
              > Задать вопрос
            </inertia-link>

            <!--<inertia-link class="header__menu-item" href="/top">Лучшие тестировщики</inertia-link>-->
          </div>

          <span class="header__map header__map--mobile">
            <!--<svg viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                     <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M0 0h4.8v4.8H0V0zm0 6.6h4.8v4.8H0V6.6zM11.4 0H6.6v4.8h4.8V0zM6.6 6.6h4.8v4.8H6.6V6.6zM18 0h-4.8v4.8H18V0zm-4.8 6.6H18v4.8h-4.8V6.6zm-8.4 6.6H0V18h4.8v-4.8zm1.8 0h4.8V18H6.6v-4.8zm11.4 0h-4.8V18H18v-4.8z"
                        fill="#9198A0"></path>
                  </svg>
                  <span>Все сервисы</span>-->
          </span>

          <p class="header__support">
            Круглосуточная служба поддержки:
          </p>
          <a
            class="header__phone"
            href="tel:88002501111"
          >
            8 800 250 11 11
          </a>
          <a
            v-if="isAuth"
            class="header__logout"
            href="/logout"
          >
            Выйти
            <svg class="ico ico-mono-logout">
              <use :xlink:href="'/images/sprite-mono.svg#ico-mono-logout'" />
            </svg>
          </a>
          <a
            v-if="!isAuth"
            class="header__logout"
            href="/oauth/redirect"
          ><span class="px-2 py-1">Войти</span> </a>
        </div>
      </div>
      <!--      <a-->
      <!--        class="flex items-center md:p-2.5 p-1.5 md:text-xs text-[10px] font-bold tracking-wider uppercase font-wide text-white rounded-2xl bg-brand"-->
      <!--        href="/oauth/redirect"-->
      <!--        v-if="!isAuth"-->
      <!--      ><span class="px-2 py-1">Войти</span>-->
      <!--      </a>-->
      <!--<a
        class="flex items-center md:p-2.5 p-1.5 md:text-xs text-[10px] font-bold tracking-wider uppercase font-wide text-white rounded-2xl bg-brand"
        href="/logout"
        v-else
        ><span class="px-2 py-1">Выйти</span></a
      >-->
    </div>
  </header>
</template>

<script>
import { mapGetters } from 'vuex';
import ProfileWidget from '../Profile/ProfileWidget';
import { loginClickEvent } from '../../libs/analytics';
import DropdownMenu from '../Shared/DropdownMenu.vue';
import HeaderLogo from '../icons/HeaderLogo.vue';
// import Notifications from './Notifications'

export default {
  name: 'HeaderMain',

  components: {
    ProfileWidget,
    DropdownMenu,
    HeaderLogo,
    // Notifications
  },

  data() {
    return {
      showMenu: false,
    };
  },

  computed: {
    ...mapGetters({
      authUser: 'auth/user',
      isAuthAlphaTester: 'auth/isAuthAlphaTester',
      adminHasAccess: 'auth/adminHasAccess',
      previewMode: 'tests/previewMode',
      startMode: 'tests/startMode',
    }),
    hideHeader() {
      return this.previewMode || this.startMode;
    },
    isAuth() {
      return Boolean(this.$page.props.user?.id);
    },
    showAlpha() {
      return this.$page.props.roles.includes('alpha');
    },
    isModerator() {
      return this.$page.props.roles.includes('moderator');
    },
    isQuickTestsModerator() {
      return this.$page.props.roles.includes('quick_tests_moderator');
    },
    hasAccessAdmin() {
      return (
        this.isAuth &&
        this.$page.props.roles &&
        this.$page.props.roles.length &&
        this.adminHasAccess(['admin', 'product_owner', 'moderator', 'create_draft'])
      );
    },
    hasAccess() {
      return (
        this.isAuth &&
        this.$page.props.roles &&
        this.$page.props.roles.length &&
        this.adminHasAccess(['admin', 'product_owner', 'moderator', 'create_draft', 'beta', 'alpha'])
      );
    },
  },
  mounted() {
    this.$inertia.on('start', () => {
      this.showMenu = false;
      document.documentElement.style.overflow = 'auto';
    });
  },

  methods: {
    fireLoginEvent(eventElement) {
      loginClickEvent(
        {
          eventContent: 'voiti',
          eventContext: 'screen',
        },
        eventElement,
      );
    },
    toggleMenu() {
      this.showMenu = !this.showMenu;

      if (this.showMenu) {
        document.documentElement.style.overflow = 'hidden';

        return;
      }
      document.documentElement.style.overflow = 'auto';
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .dropdown-content {
  margin-left: 5px;
}

.header__menu-item {
  margin-left: 10px !important;
  margin-right: 10px !important;
}

.header__active-buttons {
  display: none;
}

.btn--admin {
  color: #ff0032;
  cursor: pointer;
}

.btn-mobile {
  display: inline-block;
  position: relative;
  cursor: pointer;
  background: #ff0032;
  border-radius: 6px;
  color: #fff;
  font-size: 12px;
  font-family: MTS Compact Medium, Helvetica, Arial, sans-serif;
  text-align: center;
  line-height: 1.3;
  padding: 8px 12px;
  transition: all .25s ease-in-out;
  box-sizing: border-box;
  border: 1px solid #ff0032;
}

.header__register-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-right: 16px;
  height: 34px;
  padding: 6px 10px;
  border: 0;
  border-radius: 8px;
  background: #ff0032;
  color: #ffffff;
  font-family: MTS Wide, Helvetica, Arial, sans-serif;
  font-weight: 700;
  font-size: 9px;
  line-height: 10px;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  text-decoration: none;
}

.header__register-btn:hover {
  color: #ffffff;
}

// hide admin btn for mobile
@media only screen and (max-width: 1024px) {
  .btn--admin {
    display: block;
  }
}

@media only screen and (max-width: 768px) {
  .header__active-buttons {
    display: block;
  }
}
</style>
